import { Grid, IconButton } from "@material-ui/core";
import IconDelete from "app/common/Icon/IconDelete";
import { LEAD_SOURCE_LEVEL, VOUCHER_INVOICE_TYPE } from "app/common/LocalConst";
import { formatMoney, getDateTime } from "app/common/LocalFunction";
import { getListCode } from "app/services/CustomerSourceService";
import { FieldArray, getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import { memo } from "react";

function VoucherDepositDeductionTable() {
    const { values, setFieldValue } = useFormikContext();

    const handleGetListCodeSource = async (obj) => {
        try {
            const { data } = await getListCode(obj);
            setFieldValue("listCodeSource", data || []);
        } catch (error) {
            // handle error nếu cần
        }
    };
    // patient ko đổi nên lấy từ old được
    const patientId =
        values?.patient?.id ||
        values?.oldTreatmentPlanCard?.patient?.id ||
        values?.oldPatientServiceRegister?.patient?.id ||
        values?.oldProduct?.patient?.id;

    // thông tin khác thì phải lấy từ form hiện tại
    const invoiceItemAllocations =
        values?.invoiceItemAllocations ||
        values?.newTreatmentPlanCard?.invoiceItemAllocations ||
        values?.newPatientServiceRegister?.invoiceItemAllocations ||
        values?.newProduct?.invoiceItemAllocations || [];
    const voucherAllocations =
        values?.voucherAllocations ||
        values?.newTreatmentPlanCard?.voucherAllocations ||
        values?.newPatientServiceRegister?.voucherAllocations ||
        values?.newProduct?.voucherAllocations || [];
    const startDate =
        values?.startDate ||
        values?.orderDate ||
        values?.newTreatmentPlanCard?.startDate ||
        values?.newTreatmentPlanCard?.orderDate ||
        values?.newPatientServiceRegister?.startDate ||
        values?.newPatientServiceRegister?.orderDate ||
        values?.newProduct?.startDate ||
        values?.newProduct?.orderDate;
    const departmentId =
        values?.department?.id ||
        values?.newTreatmentPlanCard?.department?.id ||
        values?.newPatientServiceRegister?.department?.id ||
        values?.newProduct?.department?.id;

    const handleRemove = (removeIndex) => {
        const remainVouchers = Array.isArray(voucherAllocations)
            ? voucherAllocations.filter((_, index) => index !== removeIndex)
            : [];

        const searchCodeSource = {
            level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
            startDate: startDate,
            patientId: patientId,
            departmentId: departmentId,

            // 👉 chỉ lấy voucher còn lại
            voucherIds: remainVouchers
                .map(item => item?.voucher?.id)
                .filter(Boolean),

            invoiceItemIds: Array.isArray(invoiceItemAllocations)
                ? invoiceItemAllocations
                    .map(item => item?.invoiceItem?.id)
                    .filter(Boolean)
                : [],
        };

        handleGetListCodeSource(searchCodeSource);
    };

    return (
        <FieldArray name="voucherAllocations">
            {({ remove }) => (
                <Grid item xs={12}>
                    <div className="table-root mt-2">
                        <div style={{ minWidth: "760px" }}>
                            <table className="table-container">
                                <thead>
                                    <tr className="row-table-header">
                                        <th width="5%">STT</th>
                                        <th width="10%">Ngày lập hóa đơn</th>
                                        <th width="10%">Mã</th>
                                        <th width="10%">Tổng tiền</th>
                                        <th width="8%">Loại</th>
                                        <th width="10%">Cơ sở</th>
                                        <th width="10%">Thu ngân</th>
                                        <th width="20%">Ghi chú</th>
                                        <th width="8%" align="center">Thao tác</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {Array.isArray(values?.voucherAllocations) &&
                                        values.voucherAllocations.length > 0 ? (
                                        values.voucherAllocations.map((item, i) => (
                                            <tr key={i}>
                                                <td align="center">{i + 1}</td>
                                                <td align="center">
                                                    {getDateTime(item?.voucher?.voucherDate)}
                                                </td>
                                                <td align="center">
                                                    {item?.voucher?.code}
                                                </td>
                                                <td align="left">
                                                    {formatMoney(item?.voucher?.moneyAfterDiscount)}
                                                </td>
                                                <td align="left">
                                                    {
                                                        VOUCHER_INVOICE_TYPE?.find(
                                                            el =>
                                                                el.value ===
                                                                item?.voucher?.voucherInvoiceType
                                                        )?.name
                                                    }
                                                </td>
                                                <td align="center">
                                                    {item?.voucher?.department?.name}
                                                </td>
                                                <td align="center">
                                                    {item?.voucher?.accountant?.staffName}
                                                </td>
                                                <td align="center">
                                                    {item?.voucher?.note}
                                                </td>
                                                <td align="center">
                                                    <IconButton
                                                        size="small"
                                                        color="secondary"
                                                        onClick={() => {
                                                            remove(i);
                                                            handleRemove(i);
                                                        }}
                                                    >
                                                        <IconDelete />
                                                    </IconButton>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan={9}
                                                align="center"
                                                style={{ fontStyle: "italic" }}
                                            >
                                                Không có dữ liệu
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Grid>
            )}
        </FieldArray>
    );
}

export default memo(observer(VoucherDepositDeductionTable));
